import {
  FETCH_ALL_FIELDS_BY_ORG_SUCCESS,
  FETCH_ALL_FIELDS_BY_ORG_LOADING,
  FETCH_ALL_FIELDS_BY_ORG_ERROR,
  FETCH_FIELDS_BY_ID_LOADING,
  FETCH_FIELDS_BY_ID_SUCCESS,
  FETCH_FIELDS_BY_ID_ERROR,
  UPDATE_EXISTING_PROPERTY_IDS,
  RESET_ALL_FIELDS
} from '../actions/types';

const initialState = {
  loading: false,
  error: null,
  data: [],
  propertiesIDs: [],
  propertyFieldEntities: {},
  fieldById: {}
};

export const allFields = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_FIELDS_BY_ORG_LOADING:
      return {
        ...state,
        error: null,
        loading: true
      };
    case UPDATE_EXISTING_PROPERTY_IDS:
      return {
        ...state,
        propertiesIDs: action.payload
      };
    case 'UPDATE_PROPERTIES_FIELDS_ENTITIES':
      return {
        ...state,
        loading: false,
        error: null,
        propertyFieldEntities: action.payload
      };
    case FETCH_ALL_FIELDS_BY_ORG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload
      };
    case FETCH_ALL_FIELDS_BY_ORG_ERROR:
      return {
        ...initialState,
        data: action.err
      };
    case FETCH_FIELDS_BY_ID_SUCCESS:
      return {
        ...state,
        fieldById: action.payload,
        loading: false
      };
    case FETCH_FIELDS_BY_ID_LOADING:
      return {
        ...state,
        loading: true
      };
    case FETCH_FIELDS_BY_ID_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case RESET_ALL_FIELDS:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
